module.exports = __webpack_public_path__ + "img/icon_map_199_on_010.7346563b.png";